import { useTranslation } from 'react-i18next'
import { InputTextProps } from '../InputText/types'
import * as React from 'react'
import InputText from '../InputText/InputText'
import Icon from '../Icon'
import '@sass/_input-search.scss'
import {usePantameraService} from "@frontendUtils/pantamera-service";
const { getCssVariable } = usePantameraService();

const InputSearch = ({
    hideLabel = true,
    required = false,
    ...props
}: InputTextProps) => {
    const { t } = useTranslation();
    const iconColor = getCssVariable('search-icon-color');

    return (
        <div className={`input-search ${props.inputSearchClassName}__input-search`} >
            <InputText
                id={props.id}
                inputClassName={props.inputClassName}
                inputSearchClassName={props.inputSearchClassName}
                className={props.className}
                label={props.label}
                placeholder={props.placeholder || t('placeholder.search')}
                hideLabel={hideLabel}
                required={required}
                value={props.value}
                maxLength={props.maxLength || undefined}
                autoComplete={props.autoComplete || 'on'}
                onChange={props.onChange}
            />
            <Icon iconName="search" className={props.iconClassName} size={14} color={iconColor}/>
        </div>
    )
}

export default InputSearch;
